"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const appConstants_1 = require("../../../../../constants/appConstants");
const strings_1 = require("../../../../../constants/strings");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const codingQuery_1 = require("../../../../../queries/codingQuery");
const simpleButton_1 = __importDefault(require("../../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../../organisms/drawerAside"));
const useCodingListState_1 = require("../kooks/useCodingListState");
const CODING_LIST_TABLE_CHANGE_TEAM_OPTION_TEMPLATE = ({ teamName }) => appConstants_1.codingListConstants.codingListTableChangeTeamOptionTemplate({ teamName });
const onCodingEntryTeamsChange = ({ selectedCodingList, currentSelectedCodingEntry, toggleCodingListEntryQuery, currentCodingEntryTeams, setIsCodingListSelectorAsideOpen, setNotification, company, }) => {
    for (const entry of currentCodingEntryTeams) {
        toggleCodingListEntryQuery.mutate({
            codingListCode: selectedCodingList.id,
            codingEntryId: currentSelectedCodingEntry.ID,
            teamId: entry.teamId,
            state: entry.state,
            companyId: company.companyId,
        });
    }
    setIsCodingListSelectorAsideOpen(false);
    setNotification([
        {
            type: strings_1.notificationStrings.SUCCESS,
            message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
        },
    ]);
};
const getChangeTeamEntryAsideContent = ({ currentCodingEntryTeams, setNewCodingEntryTeams, selectedCodingList, toggleCodingListEntryQuery, setIsCodingListSelectorAsideOpen, updateSelectedCodingEntryTeamByTeamId, company, isNewEntryAsideOpen, currentSelectedCodingEntry, setNotification, }) => {
    const elements = [];
    if (currentCodingEntryTeams && currentCodingEntryTeams.length > 0) {
        const allChecked = currentCodingEntryTeams?.every(entry => entry.state);
        const anyChecked = currentCodingEntryTeams?.some(entry => entry.state);
        elements.push((0, jsx_runtime_1.jsx)(material_1.FormControl, { sx: { mT: '0', p: '5px' }, children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { labelPlacement: "start", control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { name: "selectAll", checked: allChecked, indeterminate: !allChecked && anyChecked, onChange: (_event, checked) => {
                        const updatedTeams = currentCodingEntryTeams?.map(entry => ({
                            ...entry,
                            state: checked,
                        }));
                        updatedTeams.forEach(entry => {
                            updateSelectedCodingEntryTeamByTeamId(entry);
                        });
                    } }), label: "Select / Deselect All" }) }, "selectAll"));
        for (const entry of currentCodingEntryTeams) {
            elements.push((0, jsx_runtime_1.jsx)(material_1.FormControl, { "data-testid": entry.teamId || '', sx: { mT: '0', p: '5px' }, children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { labelPlacement: "start", control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { name: entry.teamId, checked: entry.state, onChange: (_event, checked) => {
                            const updatedEntry = {
                                ...entry,
                                state: checked,
                            };
                            updateSelectedCodingEntryTeamByTeamId(updatedEntry);
                        } }), label: entry.teamName }) }, CODING_LIST_TABLE_CHANGE_TEAM_OPTION_TEMPLATE({ teamName: entry.teamName })));
        }
    }
    elements.push((0, jsx_runtime_1.jsx)(simpleButton_1.default, { "data-testid": selectedCodingList.id || '', dataTestId: "save-btn", disabled: currentCodingEntryTeams?.length === 0, label: strings_1.companySettingsCodingStrings.CHANGE_TEAM_ASIDE_SAVE_BUTTON, style: { width: '100%', marginTop: '20px' }, onClick: () => {
            if (isNewEntryAsideOpen) {
                setNewCodingEntryTeams([...currentCodingEntryTeams]);
            }
            else {
                onCodingEntryTeamsChange({
                    selectedCodingList,
                    currentSelectedCodingEntry,
                    toggleCodingListEntryQuery,
                    currentCodingEntryTeams,
                    setIsCodingListSelectorAsideOpen,
                    setNotification,
                    company,
                });
            }
            setIsCodingListSelectorAsideOpen(false);
        } }, appConstants_1.codingListConstants.codingListTableChangeTeamSaveButton), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "renameList-btn", label: strings_1.companySettingsCodingStrings.RENAME_LIST_INPUT_CANCEL_BUTTON, color: uiConstants_1.UI_BUTTON_SECONDARY, onClick: () => setIsCodingListSelectorAsideOpen(false), style: { width: '100%', marginTop: '10px' } }, appConstants_1.codingListConstants.codingListChangeTeamCancelButton));
    return (0, jsx_runtime_1.jsx)(material_1.FormGroup, { children: elements });
};
const SelectTeamsAside = () => {
    const state = (0, useCodingListState_1.useCodingPageState)();
    const toggleCodingListEntryQuery = (0, codingQuery_1.useToggleCodingListEntryQuery)();
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: appConstants_1.codingListConstants.codingListTeamSelectorAsideId, title: strings_1.companySettingsCodingStrings.CHANGE_TEAM_ASIDE_TITLE, open: state.isOpenCodingListSelectorAside, onClose: () => state.setIsCodingListSelectorAsideOpen(false), footerButtons: null, children: (0, jsx_runtime_1.jsx)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: getChangeTeamEntryAsideContent({
                currentCodingEntryTeams: state.currentCodingEntryTeams,
                setNewCodingEntryTeams: state.setNewCodingEntryTeams,
                selectedCodingList: state.currentCodingListSelected,
                toggleCodingListEntryQuery,
                setIsCodingListSelectorAsideOpen: state.setIsCodingListSelectorAsideOpen,
                updateSelectedCodingEntryTeamByTeamId: state.updateSelectedCodingEntryTeamByTeamId,
                company: state.company,
                isNewEntryAsideOpen: state.isNewEntryAsideOpen,
                currentSelectedCodingEntry: state.currentSelectedCodingEntry,
                setNotification: state.setNotification,
            }) }) }));
};
exports.default = SelectTeamsAside;
